import { IsString, IsOptional, IsBoolean } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class CreateZonaCobranzaDto {
  @ApiProperty({ description: 'Nombre de la zona' })
  @IsString()
  nombre: string;

  @ApiPropertyOptional({ description: 'Descripción de la zona' })
  @IsOptional()
  @IsString()
  descripcion?: string;

  @ApiPropertyOptional({ description: 'Estado activo/inactivo', default: true })
  @IsOptional()
  @IsBoolean()
  active?: boolean;
}
